import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { safeResumeNext } from '@/lib/oauthNext';

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="w-8 h-8 border-2 border-[var(--ink-1)] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!user) {
    // A recovery email's link: sign in first, then back to that checkout.
    const resume = safeResumeNext(location.pathname + location.search);
    if (resume) return <Navigate to={`/login?next=${encodeURIComponent(resume)}`} replace />;
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return children;
}
